
import ArchiveAdd from "../../../assets/duotone/ArchiveAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArchiveAddIcon({ className, dataTestid = "ArchiveAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArchiveAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
